import { useState } from 'react';

const useOrderBy = (orderByValue = null, orderTypeValue = null) => {
  const [orderBy, setOrderBy] = useState(orderByValue);
  const [orderType, setOrderType] = useState(orderTypeValue);

  const handleColumnClick = (column) => {
    if (orderType === column) {
      // Si ya se hizo clic en la misma columna, cambiar el tipo de ordenamiento
      setOrderBy(orderBy === 'ASC' ? 'DESC' : 'ASC');
    } else {
      // Si es una nueva columna, establecerla como la columna seleccionada y ordenar de forma ascendente
      setOrderType(column);
      setOrderBy('ASC');
    }
  };
  const resetState = () => {
    setOrderBy(null);
    setOrderType(null);
  };

  return { orderBy, orderType, handleColumnClick, resetState };
};

export default useOrderBy;
